import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import { InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import FormTextField from '../../common/components/FormTextField';

interface Props {
    label: string;
    value: string;
    onChange: (value: string) => void;
    hasError: boolean;
    helperText: string | null;
    required?: boolean;
    onKeyDown?: (event: KeyboardEvent) => void;
}

export default function PasswordTextField({label, value, onChange, hasError, helperText, required, onKeyDown}: Props) {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <FormTextField
            variant="standard"
            required={required}
            onKeyDown={onKeyDown}
            type={isVisible ? 'text' : 'password'}
            value={value}
            onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChange(event.target.value)}
            label={label}
            error={hasError}
            helperText={hasError && helperText ? helperText: ''}
            slotProps={{
            input: {
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setIsVisible(!isVisible)}
                            edge="end"
                        >
                            {isVisible ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            },
            }}
        />
    );
}
